module.exports = __webpack_public_path__ + "static/media/ic_asana.39e4ee43.svg";